class Url {
    constructor(url) {
        if (!url) {
            url = window.location.href;
        }
        // console.debug(url);
        // protocol :// hostname[:port] / path / [;parameters][?query]#fragment
        let pattern = /^(.+):\/\/([^:/?#]+)(:([0-9]+))?(\/[^?#]+)?(\?[^#]+)?(#.+)?$/;
        let matcher = url.match(pattern);
        if (!matcher) {
            return;
        }
        this.protocol = matcher[1];
        this.hostname = matcher[2];
        this.port = matcher[4];
        this.path = matcher[5];
        this.query = matcher[6];
        this.fragment = matcher[7];
    }

    getProtocol() {
        return this.protocol;
    }

    getHostname() {
        return this.hostname;
    }

    getPort() {
        return this.port;
    }

    getPath() {
        return this.path;
    }

    getQuery(key) {
        if (!key) {
            return this.query;
        }
        if (!this.query) {
            return this.query;
        }
        key = Url.encode(key);
        let queryPattern = eval("/^\\?.*"+key+"=([^&]+).*$/");
        let matcher = this.query.match(queryPattern);
        if (!matcher) {
            return null;
        }
        return Url.decode(matcher[1]);
    }

    addQuery(key, value) {
        key = Url.encode(key);
        value = Url.encode(value);
        if (!this.query) {
            this.query = "?";
        } else {
            this.query = this.query + "&";
        }
        this.query = this.query + key + "=" + value;

    }

    getFragment() {
        return this.fragment;
    }

    toString() {
        return this.protocol + "://" + this.hostname + (this.port ? (":" + this.port) : "") + (this.path||"") + (this.query||"") + (this.fragment||"");
    }
    
    static encode(url) {
        if (url instanceof Url) {
            url = url.toString();
        }
        return encodeURIComponent(url);
    }
    
    static decode(url) {
        return decodeURIComponent(url);
    }
}

export default Url;